/**=========================================================
 * Module: templates.js
 * Templates Controller
 =========================================================*/

App.controller('TemplatesController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', 'ngDialog',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, ngDialog) {
    "use strict";

    $scope.type = 'template';
    $scope.filter = $state.params.filter;

    $scope.data = [];

    $scope.page = {
            title: 'labels.TEMPLATES',
            subTitle: ''
        };

    $scope.initialized = false;
    $scope.watchActivated = false;
    $scope.init = function(){

        if($rootScope.user.id){
            $scope.initialized = true;

            if($state.params.action == 'list'){
                $scope.table = {
                    title: '',
                    type: 'template',
                    cls: 'no-panel-table',
                    includedFields: ['id'],
                    filter: true,
                    fields: [
                        {
                            available: true,
                            hasLink: true,
                            name: 'name',
                            filterType: 'text',
                            filterValue: ''
                        },{
                            available: true,
                            hasLink: true,
                            name: 'subject',
                            filterType: 'text',
                            filterValue: ''
                        },{
                            available: true,
                            hasLink: true,
                            name: 'language',
                            filterType: 'language',
                            filterValue: ''
                        },{
                            available: true,
                            name: 'action'
                        },{
                            available: true,
                            name: 'link'
                        }
                    ],
                    link: {
                        action: 'edit',
                        type: 'template',
                        filter: 'id'
                    },
                    links:[{
                        link: {
                            action: 'manage',
                            type:'templates',
                            filter: ''
                        },
                        label: 'labels.MANAGETEMPLATES'
                    }]
                };
            } else if($state.params.action == 'manage'){

                $scope.viewFile = function(link){
                    $scope.fileContent = ''
                    ngDialog.open({
                        template: '/app/views/entities/template-file.html',
                        className: 'ngdialog-theme-default ngdialog-theme-large',
                        scope: $scope
                    });
                    fetch(link).then(function(response){
                        response.text().then(function(text){
                            $timeout(function(){$scope.fileContent = text},10)
                        })
                    })
                }

                $scope.viewTemplate = function(id){
                    $scope.template = {}
                    ngDialog.open({
                        template: '/app/views/entities/template-view.html',
                        className: 'ngdialog-theme-default ngdialog-theme-large',
                        scope: $scope
                    });
                    D.load('template', id).then(function(result){
                        $scope.template = result;
                        
                    })
                }

                let loadTemplates = function(){
                    D.query('template','').then(function(result){
                        for(var i = 0; i < result.length; i++){
                            for(var j = 0; j < $scope.objects.length; j++){
                                if($scope.objects[j].Name.endsWith(result[i].name.toLowerCase() + '-' + result[i].language.toLowerCase() + '.html')){
                                    $scope.objects[j].templatedate = result[i].T
                                    $scope.objects[j].templateId = result[i].id
                                }
                            }
                        }
                    })
                }

                D.load('gcp', 'storagefiles::templates').then(function(result){
                    
                    $scope.objects = result.data.objects;

                    loadTemplates();

                    let templates = [{value: 'ALL' }];
                    let languages = [{value: 'ALL' }];
                    let addedT = [];
                    let addedL = []

                    for(var i = 0; i < $scope.objects.length; i++){
                        let name = $scope.objects[i].Name.split('/')[1];
                        if(name.endsWith('.html')){
                            let template = name.split('-')[0]
                            let language = name.split('-')[1].split('.')[0]
                            if(addedT.indexOf(template) < 0){
                                templates.push({value: template});
                                addedT.push(template);
                            }
                            if(addedL.indexOf(language) < 0){
                                languages.push({value: language});
                                addedL.push(language);
                            }
                        }
                    }

                    $scope.saveTemplatesForm = {
                        title: 'Save Templates',
                        status: '',
                        type: 'template',
                        model: { action:'SaveTemplates' },
                        fields: [
                            {
                                available: true,
                                type: 'select',
                                name: 'template',
                                data: templates,
                                valueField: 'value',
                                labelField: 'value',
                            },
                            {
                                available: true,
                                type: 'select',
                                name: 'language',
                                data: languages,
                                valueField: 'value',
                                labelField: 'value',
                            },{
                                available: true,
                                type: 'submit'
                            }
                        ],
                        submit: function(){
                            ngDialog.openConfirm({
                                template: '/app/views/entities/confirm.html',
                                className: 'ngdialog-theme-default',
                                scope: $scope
                            }).then(function(value){
                                $scope.saveTemplatesForm.status = 'submitting'
                                D.save('template', $scope.saveTemplatesForm.model).then(function(){
                                    $scope.saveTemplatesForm.status = 'submitted'
                                    D.load('gcp', 'storagefiles::templates').then(function(result){
                                        $scope.objects = result.data.objects;
                                        loadTemplates()
                                    })
                                }).catch(function(err){
                                    $scope.saveTemplatesForm.status = 'error'
                                
                                })
                            })
                        }
                    }

                    $scope.uploadTemplateForm = {
                        title: 'Import Template',
                        status: '',
                        type: 'template',
                        model: { tempId: '' + new Date().getTime(), action:'ImportTemplate' },
                        fields: [
                            {
                                available: true,
                                type: 'file',
                                name: 'template',
                                limit: -1,
                                noLabel: true,
                                inputColumn: 12,
                                labelColumn: 0,
                                allow: 'html', 
                                canUpload: true,
                                cantDelete: true,
                                filepath: '//templates',
                                bucket: $rootScope.bucketName(''),
                                onupload: function(){
                                    D.load('gcp', 'storagefiles::templates').then(function(result){
                                        $scope.objects = result.data.objects;
                                        loadTemplates()
                                    })
                                }
                            },{
                                available: true,
                                type: 'select',
                                name: 'template',
                                data: templates,
                                valueField: 'value',
                                labelField: 'value',
                            },
                            {
                                available: true,
                                type: 'select',
                                name: 'language',
                                data: languages,
                                valueField: 'value',
                                labelField: 'value',
                            },{
                                available: true,
                                type: 'submit'
                            }
                        ],
                        submit: function(){
                            ngDialog.openConfirm({
                                template: '/app/views/entities/confirm.html',
                                className: 'ngdialog-theme-default',
                                scope: $scope
                            }).then(function(value){
                                $scope.uploadTemplateForm.status = 'submitting'
                                D.save('template', $scope.uploadTemplateForm.model).then(function(){
                                    $scope.uploadTemplateForm.status = 'submitted'
                                }).catch(function(err){
                                    $scope.uploadTemplateForm.status = 'error'
                                
                                })
                            })
                        }
                    };
                })

                
            }

            

        } else {
            if(!$scope.watchActivated){
                $scope.watchActivated = true;
                $rootScope.$watch('user.id', function(){
                    if(!$scope.initialized){
                        $scope.init();
                    }
                });
            }
        }
    }

    $scope.init();

    $scope.$on('$destroy', function iVeBeenDismissed() {
      // say goodbye to your controller here
      // release resources, cancel request...
    });

}]);
